import {
  banners,
  checkNotAllowAdv,
  disableScroll,
  getCookie,
  hitPageView,
} from '../utils/fn';

import device from "current-device";
import { topsideBanner } from '../utils/adv-stroeer-gallery';

export let loadGallery = (args) => {
  const $window = $(window);
  let {
    arrayPhotos,
    galleryId,
    indexOf,
    $galleryList,
    onMobileOff,
    onMobileLandscapeOff,
    additionalParams,
    photosAmount,
  } = args;
  let arrayOfGalleryVideoAdsEdtns = ['us', 'ev_us', 'ra_us', 'fr', 'it'];
  let currentEdition = document.body.dataset.edtn;
  let initialTimeoutExpired = false;

  function turnedInitialTimeout() {
    initialTimeoutExpired = false;
    // console.log('TURNED');
  }

  function reinitiateBanners(wrapper) {
    initialTimeoutExpired = true;
    banners(wrapper);
  }
  
  let defaults = {
        dynamicGallery: false,
        selector: '',
        singleLoad: false,
      },
      options = Object.assign(defaults, additionalParams);

  window.history.pushState( {} , null, window.location.href );
  $window.on('popstate', function() {
    $('.lg-close').trigger('click');
  });

  $galleryList.data('page-location', document.location.pathname);

  function initSeedTag() {
    const editionCode = document.body.dataset.edtn || '';

    if (document.cookie.includes('_cpauthhint=1')) {
      return;
    }

    if (checkNotAllowAdv()) return;

    let seedTagUrl = '';
    if (editionCode === 'de') {
      seedTagUrl = 'https://t.seedtag.com/t/8025-1054-01.js';
    } else if (editionCode === 'ev_de') {
      seedTagUrl = 'https://t.seedtag.com/t/7038-0559-01.js';
    }

    if (seedTagUrl !== '') {
      const seedScript = document.createElement('script');
      seedScript.async = true;
      seedScript.src = seedTagUrl;
      document.head.appendChild(seedScript);
    }
  }

  function removeSeedTag() {
    const seedTagScript = document.querySelector('script[src*="seedtag"]');
    if (seedTagScript) {
      seedTagScript.remove();
    }
  }

  $galleryList
    // those events should be called with "one" to prevent multiple events
    // this is required for correct banners initialization when we use Relevant Yield
    .one('onBeforeOpen.lg', function (event) {
      const $lgApi = $(this).data('lightGallery'),
        outerEl = $lgApi?.$outer.get(0) || null;
      $window.trigger('msntGalleryBeforeOpen', [null, outerEl]);
    })
    .one('onAfterOpen.lg', function (event) {
      const $lgApi = $(this).data('lightGallery'),
        outerEl = $lgApi?.$outer.get(0) || null;

      initSeedTag();

      $window.trigger('msntGalleryAfterOpen', [null, outerEl]);

      $(document).on('keydown.lg', function(e) {
        if (e.key === 'Escape' || e.keyCode === 27) { // ESC
          const currentLgInstance = $galleryList.data('lightGallery');
          if (currentLgInstance && currentLgInstance.$outer && currentLgInstance.$outer.hasClass('lg-visible')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            currentLgInstance.destroy();
          }
        }
      });

      if (!$lgApi.s.counter) {
        $('.lg-toolbar').append(
          '<div id="lg-counter" class="custom-counter"><span id="lg-counter-current"> </span>/<span id="lg-counter-all"></span></div>',
        );
        const generaCounter = document.getElementById('lg-counter-all');
        const currentCounter = document.getElementById('lg-counter-current');

        if (generaCounter) {
          generaCounter.innerText = photosAmount;
        }

        if (currentCounter) {
          const openedIndex = $lgApi.index;
          const currentSlideNum = $lgApi.$items[openedIndex]?.photoNumber;
          const displayNumber = currentSlideNum !== undefined && currentSlideNum !== null 
                              ? currentSlideNum + 1 
                              : openedIndex + 1;
                              
          currentCounter.innerText = displayNumber;
        }
      }
    })
    .one('onBeforeClose.lg', function (event) {
      const $lgApi = $(this).data('lightGallery'),
        outerEl = $lgApi?.$outer.get(0) || null;

      $window.trigger('msntGalleryBeforeClose', [null, outerEl]);
    })
    .one('onCloseAfter.lg', function (event) {
      const $lgApi = $(this).data('lightGallery'),
        outerEl = $lgApi?.$outer.get(0) || null;

      $window.trigger('msntGalleryAfterClose', [null, outerEl]);
    })
    .lightGallery({
      galleryId: galleryId || 1,
      selector: options.selector,
      dynamic: options.dynamicGallery,
      html: true,
      index: indexOf,
      dynamicEl: arrayPhotos || [],
      hideBarsDelay: 100000,
      thumbWidth: 142,
      thumbContHeight: 90,
      thumbMargin: 5,
      exThumbImage: 'data-thumb',
      closable: false,
      showThumbByDefault: true,
      autoplayControls: onMobileOff,
      zoom: true, //onMobileOff,
      fullScreen: false,
      download: !onMobileOff,
      customContentContainerCls: 'lg-custom-content-related',
      hash: false,
      topside: true,
      aside: true,
      counter: false,
      escKey: false,
      // additional: [
      //   {
      //     html: $('.shareBox')
      //       .first()
      //       .clone(true, true)
      //       .addClass('to-up')
      //       .removeClass('big-shareBox')
      //       .removeClass('to-down'),
      //     className: 'lg-additional-share',
      //   },
      // ],
      topsideOnBeforeSlide: function (event, prevIndex, index) {
        // this.hide(); // hide dmpu in photo gallery
        var core = this.core.$items[index];
        let $this = this;

        if (core.htmlSlide) {
          this.hide();
          this.addMarkHtmlSlide();
        } else if (core.adSlide) {
          this.hide();
          // this.addMarkAdSlide();
        } else {
          this.hideMarkHtmlSlide();
          // this.hideMarkAdSlide();
          if (document.documentElement.clientWidth < 768) {
            if (document.documentElement.clientWidth <= 480) {
              if (!core.hor) {
                if (arrayPhotos == false) {
                  this.show();
                } else {
                  this.hide();
                }
              } else {
                this.show();
              }
            } else {
              this.hide();
            }
            // this.hide();
            // if(ActEachFiveSlide.params){
            //     if((index + 1)%5 == 0){
            //         var $banner = this.$boxWrapper.find('.apb.rectangle .ap');
            //         if($banner.length && !$banner.is(':empty')){
            //             $banner.removeAttr('data-ready').empty();
            //         }
            //         this.show();
            //     }else{
            //         this.hide();
            //     }
            // } else {
            //     if(index + 1 == 5){
            //         var $banner = this.$boxWrapper.find('.apb.rectangle .ap');
            //         if($banner.length && !$banner.is(':empty')){
            //             $banner.removeAttr('data-ready').empty();
            //         }
            //         this.show();
            //     }else{
            //         this.hide();
            //     }
            // }
          } else {
            this.show();
          }
        }

        if (core.adSlide) {
          this.addMarkAdSlide();
        } else {
          this.hideMarkAdSlide();
        }
      },
      topsideInit: function () {
        this.topsideOnAfterSlideTimeout = null;
        const template = document.querySelector('#ap_popup_gallery_top_tpl');

        var $topside_banner = $(template?.content).find('.apb');

        if ($topside_banner.length) {
          this.$boxWrapper.append($topside_banner.clone(true));
        } else if (
          $('body').data('edtn') == 'de' ||
          $('body').data('edtn') == 'ev_de'
        ) {
          this.$boxWrapper.append('<div class="stroer-ap"></div>');
        }
      },
      topsideOnAfterSlide: function (event, prevIndex, index) {
        var _this = this;
        function bannerInit() {
          if (_this.core.$outer.is('.lg-topside-off')) {
            return;
          }
          var $banner = _this.$boxWrapper.find('.ap');
          var $deBanner = _this.$boxWrapper.find('.stroer-ap');
          var cpAuthhint = document.cookie.includes('_cpauthhint=1');
          if ($banner.length) {
            // $banner.removeAttr('data-ready').empty();

            // timeout  is required in RY implementation
            // without it msntGallery* events trigger after banners render is called
            setTimeout(() => {
              banners(_this.$boxWrapper);
            }, 1);

            initialTimeoutExpired = true;
          } else if ($deBanner.length && !cpAuthhint) {
            topsideBanner($deBanner, 'top');
          }
        }
        // function skinInit() {
        //   if (_this.core.$outer.is('.lg-topside-off')) {
        //     return;
        //   }
        //   var $skinHolder = _this.$boxWrapper.find('.skin-holder');
        //   var $banner = _this.$boxWrapper.find('.ap');
        //   if ($skinHolder.children().length > 0) {
        //     $skinHolder.children().remove();
        //     $skinHolder.removeAttr('data-init').empty();
        //   }
        // }
        clearTimeout(this.topsideOnAfterSlideTimeout);
        if (this.topsideOnAfterSlideTimeout === null) {
          bannerInit();
          // skinInit();
          this.topsideOnAfterSlideTimeout = 1;
        }
        // else {
        //   this.topsideOnAfterSlideTimeout = setTimeout(bannerInit, 1000);
        //   // this.topsideOnAfterSlideTimeout = setTimeout(skinInit, 1000);
        // }
      },
      topsideDestroy: function () {
        this.topsideOnAfterSlideTimeout = null;
      },
      asideDestroy: function () {
        this.asideOnAfterSlideTimeout = null;
      },
      asideInit: function () {
        this.asideOnAfterSlideTimeout = null;
        this.$boxWrapper.append(
          '<h2 class="asideTitle" style="display:none;"></h3>',
        );
        this.$boxWrapper.append(
          '<div class="asideCaption" style="display:none;"></div>',
        );
        this.$boxWrapper.append(
          '<div class="asideSource" style="display:none;"></div>',
        );

        // For mobile: insert asideCaption and asideSource after thumbnails
        if (device.type === 'mobile') {
          const $thumbGroup = document.querySelector('.lg-thumb-outer');
          $(
            '<div class="asideSourceMobile" style="display:none;"></div>',
          ).insertAfter($thumbGroup);
        }

        let sourceLabel =
          i18n.source ||
          document
            .querySelector('.source.entity > span')
            ?.textContent?.trim() ||
          'Source';
        var $shareBox = $('.shareBox')
          .first()
          .clone(true, true)
          .removeClass('big-shareBox');
        if ($shareBox.length) {
          this.$boxWrapper.append($shareBox);
        }

        const template = document.querySelector(
          '#ap_popup_gallery_rectangle_tpl',
        );

        var $aside_banner = $(template?.content).find('.ap');

        if ($aside_banner.length) {
          this.$boxWrapper.append($aside_banner.clone());
        } else if (
          $('body').data('edtn') == 'de' ||
          $('body').data('edtn') == 'ev_de'
        ) {
          this.$boxWrapper.append('<div class="stroer-ap"></div>');
        }
      },
      asideOnAfterSlide: function (event, prevIndex, index) {
        var _this = this;
        var $title = this.$boxWrapper.find('h2.asideTitle'),
          $caption = this.$boxWrapper.find('.asideCaption'),
          $source = this.$boxWrapper.find('.asideSource');

        let sourceLabel =
          i18n.source ||
          document
            .querySelector('.source.entity > span')
            ?.textContent?.trim() ||
          'Source';

        // Mobile: ensure asideSourceMobile exists after .lg-thumb-outer
        if (device.type === 'mobile') {
          const thumbOuter = document.querySelector('.lg-thumb-outer');
          if (thumbOuter && !document.querySelector('.asideSourceMobile')) {
            const div = document.createElement('div');
            div.className = 'asideSourceMobile';
            div.style.display = 'none';
            thumbOuter.parentNode.insertBefore(div, thumbOuter.nextSibling);
          }
        }

        if ($title && arrayPhotos) {
          let subHtml = arrayPhotos[index].subHtml;
          if (subHtml) {
            $title.show().html(subHtml);
          } else {
            let $h1 = $('h1');
            if ($h1.length) {
              $title.show().html($h1.text());
            } else {
              $title.hide();
            }
          }
          let captions = arrayPhotos[index].caption;
          let description = arrayPhotos[index].description;
          let source = arrayPhotos[index].source;
          let sourceUrl = arrayPhotos[index].sourceUrl;

          // Desktop: update .asideSource
          if ($source.length) {
            if (source && source !== 'null') {
              let label = sourceLabel + ': ';
              if (sourceUrl) {
                $source
                  .html(
                    '<span>' +
                      label +
                      '</span><a href="' +
                      sourceUrl +
                      '" target="_blank" rel="noopener noreferrer">' +
                      source +
                      '</a>',
                  )
                  .show();
              } else {
                $source.html('<span>' + label + '</span>' + source).show();
              }
            } else {
              $source.hide();
            }
          }

          // Mobile: update .asideSourceMobile
          if (device.type === 'mobile') {
            const $sourceMobile = $('.asideSourceMobile');
            if ($sourceMobile.length) {
              if (source && source !== 'null') {
                let label = sourceLabel + ': ';
                if (sourceUrl) {
                  $sourceMobile
                    .html(
                      '<span>' +
                        label +
                        '</span><a href="' +
                        sourceUrl +
                        '" target="_blank" rel="noopener noreferrer">' +
                        source +
                        '</a>',
                    )
                    .show();
                } else {
                  $sourceMobile
                    .html('<span>' + label + '</span>' + source)
                    .show();
                }
              } else {
                $sourceMobile.remove();
              }
            }
          }

          if (description || captions) {
            $caption.html(description || captions).show();
          } else {
            $caption.hide();
          }
        }
        if (document.documentElement.clientWidth < 1024) {
          return;
        }
        function bannerInit() {
          var $banner = _this.$boxWrapper.find('.ap');
          var $deBanner = _this.$boxWrapper.find('.stroer-ap');
          var cpAuthhint = document.cookie.includes('_cpauthhint=1');
          if ($banner.length) {
            // $banner.removeAttr('data-ready').empty();

            // timeout  is required in RY implementation
            // without it msntGallery* events trigger after banners render is called
            setTimeout(() => {
              banners(_this.$boxWrapper);
            }, 1);
          } else if ($deBanner.length && !cpAuthhint) {
            topsideBanner($deBanner, 'sidebar');
          }
        }
        clearTimeout(this.asideOnAfterSlideTimeout);
        if (this.asideOnAfterSlideTimeout === null) {
          bannerInit();
          this.asideOnAfterSlideTimeout = 1;
        }
        // else {
        //   this.asideOnAfterSlideTimeout = setTimeout(bannerInit, 1000);
        // }
      },
    })
    .on('onAfterSlide.lg', function (event) {
      // console.log('onAfterSlide happened', 'index', $currentSlide);
      disableScroll();
      var lightGalleryCore = $(this).data('lightGallery');
      if ('index' in lightGalleryCore) {
        var $currentSlide = $(lightGalleryCore.$items[lightGalleryCore.index]);
          
        if ($currentSlide.length) {
          var data = $currentSlide[0];
          if ('gtmDataLayer' in window && data.entityId) {
            gtmDataLayer.push({
              event: 'popupPhotoGallaryEntityChanged',
              entityType: 'photo',
              entityId: data.entityId,
            });
          }
          if (data.photoAnchorUrl) {
            let photoUrl = data.parrentGalleryUrl + data.photoAnchorUrl;
            history.replaceState({}, null, photoUrl);
            hitPageView(data.url);
          } else {
            var pageLocation = $galleryList.data('page-location');
            if (pageLocation) {
              history.replaceState({}, null, pageLocation);
            }
          }

          if (data.adSlide) {
            if ('gtmDataLayer' in window) {
              gtmDataLayer.push({
                event: 'popupPhotoGallaryCustomSlideAds',
              });
            }

            const stroerInitEvent = new Event('stroerInitInGallery');
            document.dispatchEvent(stroerInitEvent);

            // console.log('fired');

            // var el = $('.lg-inner .lg-current + .lg-ads-as-separate .lg-custom-ads');
            // console.log(el, 'fired');
            // banners(el);
          }
        }
      }
    })
    .on('onBeforeSlide.lg', function(event) {
      // console.log('onBeforeSlide happened');
      var lightGalleryCore = $(this).data('lightGallery');
      if ('index' in lightGalleryCore) {
         if (!lightGalleryCore.s.counter) {
           let currentSlideNum =
             lightGalleryCore.$items[lightGalleryCore.index].photoNumber + 1;

           let counterCurrent = currentSlideNum;
           if (!currentSlideNum) {
             counterCurrent = currentSlideNum + 1;
           }
           if (isNaN(currentSlideNum)) {
             counterCurrent = ' ';
           }
          
           const counterCurrentSpan =
             document.getElementById('lg-counter-current');
          
           if (counterCurrentSpan) {
             counterCurrentSpan.innerText = counterCurrent;
           }
         }
      }
    })
    .on('onCustomContentReady.lg', function (event, $container) {
      // stop propagation of scroll and swipe
      // to allow scrolling of inner content
      $container
        .find('.lg-custom-content_column')
        .on('mousewheel touchstart touchmove', function (event) {
          event.stopPropagation();
        });
    })
    .on('onBeforeClose.lg', function () {
      if ($galleryList.data('ampphotoid')) {
        $galleryList.removeAttr('data-ampphotoid data-ampgalleryid');
        $galleryList.removeData('ampphotoid data-ampgalleryid');
      }

      var pageLocation = $galleryList.data('page-location');
      if (pageLocation) {
        // if($galleryList.data('slider-hash')){
        //     var lightGalleryCore = $(this).data('lightGallery');
        //     if('index' in lightGalleryCore){
        //         var $currentSlide = $(lightGalleryCore.$items[lightGalleryCore.index]);
        //         if($currentSlide.length){
        //             var h = $currentSlide.data('hash');
        //             if(h){
        //                 var $mainPhoto = $(selector).find('.msnt-photo-thumb-gallery-main-photo-box');
        //                 var $mainPhotoImage = $mainPhoto.find('img');
        //                 var src = $currentSlide.data('src');
        //                 var href = $currentSlide.data('url');
        //                 if($mainPhoto.length && $mainPhotoImage.length && src && href){
        //                     var slide_hash = '#' + h;
        //                     $galleryList.goToSlide(lightGalleryCore.index);
        //                     $mainPhoto.attr('href', href);
        //                     $mainPhotoImage.attr('src', src);
        //                     history.replaceState({}, null, pageLocation + slide_hash);
        //                 }
        //             }else{
        //                 history.replaceState({}, null, pageLocation);
        //             }
        //         }
        //     }
        // }else{
        // }
        history.replaceState({}, null, pageLocation);
      }

      $galleryList.data('full-size', false);
    })
    .on('onCloseAfter.lg', function () {
      removeSeedTag();
      if (!options.singleLoad) {
        $galleryList
          .off(
            'onAfterSlide.lg onCustomContentReady.lg onBeforeClose.lg onCloseAfter.lg',
          )
          .data('lightGallery')
          .destroy(true);
      }
      disableScroll('destroy');
      window.successResponse = true;

      $(document).off('keydown.lgEsc');
    })
    .on('onBeforeNextSlide.lg', function () {
      if (device.type == 'desktop') {
        // console.log('entered onBeforeNextSlide', initialTimeoutExpired);
        if (initialTimeoutExpired) {
          // console.log('requesting reload initialTimeoutExpired');
          turnedInitialTimeout();
          setTimeout(() => {
            reinitiateBanners($('.lg'));
          }, 15000);
        }
      }
    });
}